import * as e from "@oasisprotocol/client";
import * as r from "@oasisprotocol/client-rt";
const d = /* @__PURE__ */ new Map([
  [
    23294,
    {
      paratimeRuntimeId: "000000000000000000000000000000000000000000000000f80306c9858e7279",
      grpcUrl: "https://grpc.oasis.io"
    }
  ],
  [
    23295,
    {
      paratimeRuntimeId: "000000000000000000000000000000000000000000000000a6d1e3ebf60dff6c",
      grpcUrl: "https://testnet.grpc.oasis.io"
    }
  ]
]), u = async (t) => await e.address.fromData(
  r.address.V0_SECP256K1ETH_CONTEXT_IDENTIFIER,
  r.address.V0_SECP256K1ETH_CONTEXT_VERSION,
  e.misc.fromHex(t)
), o = (t) => {
  const s = Number(t);
  if (!d.has(s))
    throw new Error(
      `Invalid [chainId], supported chain ids are: ${Array.from(d.keys()).join(", ")}`
    );
  return d.get(s);
}, l = (t, s, n) => {
  const { paratimeRuntimeId: a } = o(t);
  return new r.consensusAccounts.Wrapper(e.misc.fromHex(a)).callDelegate().setBody({
    amount: [e.quantity.fromBigInt(n), r.token.NATIVE_DENOMINATION],
    to: e.staking.addressFromBech32(s)
  }).toSubcall();
}, I = (t, s, n) => {
  const { paratimeRuntimeId: a } = o(t);
  return new r.consensusAccounts.Wrapper(e.misc.fromHex(a)).callUndelegate().setBody({
    shares: e.quantity.fromBigInt(n),
    from: e.staking.addressFromBech32(s)
  }).toSubcall();
}, f = async (t, s) => {
  const { paratimeRuntimeId: n, grpcUrl: a } = o(t), i = await u(s);
  return (await new r.consensusAccounts.Wrapper(e.misc.fromHex(n)).queryDelegations().setArgs({ from: i }).query(new e.client.NodeInternal(a))).map(({ to: c, shares: m }) => ({
    to: e.staking.addressToBech32(c),
    shares: e.quantity.toBigInt(m)
  }));
}, h = async (t, s) => {
  const { paratimeRuntimeId: n, grpcUrl: a } = o(t), i = await u(s);
  return (await new r.consensusAccounts.Wrapper(e.misc.fromHex(n)).queryUndelegations().setArgs({ to: i }).query(new e.client.NodeInternal(a))).map(({ from: c, shares: m, epoch: p }) => ({
    from: e.staking.addressToBech32(c),
    shares: e.quantity.toBigInt(m),
    epoch: BigInt(p)
  }));
};
export {
  l as consensusDelegate,
  I as consensusUndelegate,
  f as getDelegations,
  h as getUndelegations
};
